var React = require('react');
var { createElement: h, useEffect, useRef, useState } = React;

var SKEL_LINE_PATTERNS = [
  {ml:0,  b:[{w:55,c:'kw'}, {w:36}, {w:80,c:'fn'}]},
  {ml:16, b:[{w:44,c:'str'}, {w:62}]},
  {ml:16, b:[{w:70}, {w:26,c:'kw'}, {w:48,c:'fn'}]},
  {ml:32, b:[{w:34,c:'var'}, {w:54}, {w:20}]},
  {ml:32, b:[{w:58,c:'str'}, {w:30}]},
  {ml:16, b:[{w:46}, {w:38,c:'kw'}, {w:66,c:'fn'}]},
  {ml:0,  b:[{w:18}]},
  {ml:0,  b:[{w:62,c:'kw'}, {w:40}, {w:34,c:'fn'}, {w:20}]},
  {ml:16, b:[{w:50,c:'fn'}, {w:28}]},
  {ml:32, b:[{w:38}, {w:56,c:'str'}, {w:16}]},
  {ml:32, b:[{w:44,c:'var'}, {w:60}]},
  {ml:16, b:[{w:68,c:'fn'}, {w:32,c:'kw'}]},
  {ml:0,  b:[{w:18}]},
  {ml:0,  b:[{w:74,c:'kw'}, {w:22}, {w:52,c:'fn'}]},
  {ml:16, b:[{w:48,c:'str'}, {w:64}]},
  {ml:16, b:[{w:52}, {w:30,c:'var'}, {w:42}]},
  {ml:32, b:[{w:36}, {w:50,c:'kw'}]},
  {ml:32, b:[{w:60,c:'fn'}, {w:24}, {w:38,c:'str'}]},
  {ml:16, b:[{w:40,c:'str'}]},
  {ml:0,  b:[{w:18}]},
  {ml:0,  b:[{w:30,c:'kw'}, {w:56}]},
  {ml:0,  b:[{w:58}, {w:44,c:'fn'}, {w:28}, {w:62,c:'str'}]},
  {ml:16, b:[{w:42,c:'var'}, {w:58}, {w:22,c:'kw'}]},
  {ml:32, b:[{w:34}, {w:46,c:'fn'}]},
  {ml:16, b:[{w:66,c:'fn'}]},
  {ml:0,  b:[{w:18}]},
];

/* Pool of extra tokens to append — keeps original token sizes */
var EXTRA_TOKENS = [
  {w:40,c:'kw'}, {w:52}, {w:36,c:'fn'}, {w:28,c:'str'}, {w:60,c:'var'},
  {w:48}, {w:32,c:'kw'}, {w:56,c:'fn'}, {w:44,c:'str'}, {w:24},
  {w:66}, {w:38,c:'var'}, {w:50,c:'kw'}, {w:30,c:'fn'}, {w:42},
];
var GAP = 8;

/* Fill a row up to a target coverage (40-75% of width, varies per line) */
function buildRow(pattern, availWidth, seed) {
  if (availWidth <= 0) return pattern;
  /* Each line fills 40-75% of width for natural code look */
  var coverages = [0.55, 0.70, 0.65, 0.45, 0.40, 0.75, 0.15, 0.60, 0.50, 0.55];
  var coverage = coverages[seed % coverages.length];
  var target = availWidth * coverage;
  var used = pattern.ml;
  for (var i = 0; i < pattern.b.length; i++) {
    used += pattern.b[i].w + (i > 0 ? GAP : 0);
  }
  if (used >= target) return pattern;
  var blocks = pattern.b.slice();
  var ei = (seed * 7) % EXTRA_TOKENS.length;
  while (used + GAP + EXTRA_TOKENS[ei].w < target) {
    used += GAP + EXTRA_TOKENS[ei].w;
    blocks.push(EXTRA_TOKENS[ei]);
    ei = (ei + 1) % EXTRA_TOKENS.length;
  }
  return { ml: pattern.ml, b: blocks };
}

function CodingLines() {
  var counterRef = useRef(0);
  var containerRef = useRef(null);
  var widthRef = useRef(0);
  var maxLinesRef = useRef(18);
  var linesState = useState([]);
  var lines = linesState[0];
  var setLines = linesState[1];

  useEffect(function() {
    function measure() {
      if (containerRef.current) {
        widthRef.current = containerRef.current.clientWidth - 32;
        var ch = containerRef.current.clientHeight;
        if (ch > 0) maxLinesRef.current = Math.max(18, Math.ceil(ch / 22));
      }
    }
    measure();
    window.addEventListener('resize', measure);

    function addLine() {
      var id = counterRef.current;
      var p = SKEL_LINE_PATTERNS[id % SKEL_LINE_PATTERNS.length];
      counterRef.current++;
      var row = buildRow(p, widthRef.current, id);
      var max = maxLinesRef.current;
      setLines(function(prev) {
        return prev.concat([{ id: id, ml: row.ml, b: row.b }]).slice(-max);
      });
    }
    addLine(); addLine(); addLine(); addLine();
    var timer = setInterval(addLine, 340);
    return function() {
      clearInterval(timer);
      window.removeEventListener('resize', measure);
    };
  }, []);

  useEffect(function() {
    if (containerRef.current) {
      containerRef.current.scrollTop = containerRef.current.scrollHeight;
    }
  }, [lines]);

  return h('div', { ref: containerRef, className: 'ai-flow-popover-coding-lines' },
    h('div', { className: 'ai-flow-popover-skel-track' },
      lines.map(function(line) {
        return h('div', {
          key: line.id,
          className: 'ai-flow-popover-skel-row',
          style: { marginLeft: line.ml + 'px' }
        },
          line.b.map(function(block, j) {
            return h('div', { key: j, className: 'ai-flow-popover-skel' + (block.c ? ' ai-skel-' + block.c : ''), style: { width: block.w + 'px' } });
          })
        );
      })
    )
  );
}

function CodingNodeCard(props) {
  var position = props.position || { left: 0, top: 0 };
  return h('div', {
    className: 'ai-coding-node-card',
    style: { left: position.left + 'px', top: position.top + 'px' },
    onMouseDown: function(e) { e.stopPropagation(); }
  },
    h('div', { className: 'ai-coding-node-header' },
      h('span', { className: 'ai-flow-popover-coding-spinner' }),
      h('span', { className: 'ai-flow-popover-coding-label' }, 'Coding')
    ),
    h(CodingLines, null)
  );
}

module.exports = { CodingLines: CodingLines, CodingNodeCard: CodingNodeCard };
